import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Grid,
  Button,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Note } from '../../models/note';
import { noteApiKeyStore } from '../../api/note-api-key-store';
import { SiTrackGrid } from '../../components/si-track-grid/si-track-grid';
import { columns } from './grid-columns';
import { useEffect, useState } from 'react';
import { SaveNoteFrom } from './save-note.component';
import { TabPanel } from '../../components/tab-panel';
import { UserPermissionName } from '../../models/user-permission-name';
import { useAuthorize } from '../../hooks/use-authorize';

interface NoteRequestArgs {
  projectID?: number;
  officeID?: number;
  customerID?: number;
  workOrderID?: number;
  unitID?: number;
  noteTempEntityID?: number;
  planReviewTaskID?: number;
}

interface NotesDialogProps {
  open: boolean;
  title?: string;
  noteRequestArgs: NoteRequestArgs;
  onClose: (tempID?: number) => void;
}

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

export const NotesDialog = ({ open, noteRequestArgs, onClose }: NotesDialogProps) => {
  const [value, setValue] = useState('create');
  const [noteReqArgs, setNoteReqArgs] = useState(noteRequestArgs);
  const [newNotes, saveNewNotes] = useState<Note[]>([]);
  const [editItem, setEditItem] = useState<Note>();

  const handleClosed = () => {
    onClose(noteReqArgs.noteTempEntityID);
  };

  const handleSaveNoteCompleted = (value: Note) => {
    setNoteReqArgs({ ...noteReqArgs, noteTempEntityID: value.noteTempEntityID });
    saveNewNotes([...newNotes, value]);
    setEditItem(undefined);
    setValue('view');
  };
  const handleEdit = (value: Note) => {
    setEditItem(value);
    setValue('edit');
  };
  const handleTabsChange = (event: any, value: any) => {
    if (value == "view") setEditItem(undefined);
    setValue(value);
  };

  const isAddNotePermission = !useAuthorize([UserPermissionName?.ADD_NOTE]);

  useEffect(() => {
    if (isAddNotePermission) setValue('view');
    else setValue('create');
  }, [isAddNotePermission])

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'lg'}
      // onClose={handleClosed}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ p: 0, m: 0 }}>
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="view" label={<div style={styling.tabHeading}>VIEW NOTES</div>} />
          <Tab value="create" label={<div style={styling.tabHeading}>CREATE NOTE</div>} hidden={isAddNotePermission || !!editItem} />
          <Tab value="edit" label={<div style={styling.tabHeading}>EDIT NOTE</div>} hidden={!editItem} />
        </Tabs>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <TabPanel selectedValue={value} value="view">
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <SiTrackGrid
                fileTitle='note'
                dataItems={[]}
                dataItemKey="noteID"
                columns={columns}
                queryConfig={noteApiKeyStore.getNotes(noteReqArgs)}
                onEdit={handleEdit}
                deleteMutationConfig={(item) => noteApiKeyStore.deleteNote(item.noteID)}
                actionPermissions={{
                  edit: UserPermissionName?.EDIT_NOTE,
                  delete: UserPermissionName?.DELETE_NOTE,
                  export: UserPermissionName.DOWNLOAD_GRID,
                }}
              />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <Grid container justifyContent="flex-end">
                <Button variant="outlined" style={{ width: '130px' }} onClick={handleClosed}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel selectedValue={value} value="create">
          <SaveNoteFrom
            noteRequestArgs={noteReqArgs}
            onSaveComplete={handleSaveNoteCompleted}
            onClosed={handleClosed}
          />
        </TabPanel>
        <TabPanel selectedValue={value} value="edit">
          <SaveNoteFrom
            noteRequestArgs={noteReqArgs}
            onSaveComplete={handleSaveNoteCompleted}
            note={editItem}
            onClosed={handleClosed}
          />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};
